import { call, put, all, fork, takeEvery } from 'redux-saga/effects'

import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { notify } from 'reapop'
import i18n from 'i18next'

import BookletsService from '../middlewares/booklets'

import {
  GET_BOOKLETS,
  GET_BOOKLETS_REQUEST,
  GET_BOOKLETS_REQUEST_ERROR,
  GET_BOOKLETS_REQUEST_PENDING,
  GET_BOOKLETS_REQUEST_SUCCESS,
  CREATE_BOOKLET,
  CREATE_BOOKLET_REQUEST,
  CREATE_BOOKLET_REQUEST_ERROR,
  UPDATE_BOOKLET,
  UPDATE_BOOKLET_REQUEST,
  UPDATE_BOOKLET_REQUEST_ERROR,
  GET_BOOKLET_REQUEST,
  GET_BOOKLET,
  GET_BOOKLET_TRANSACTIONS_REQUEST,
  GET_BOOKLET_TRANSACTIONS,
  GET_BOOKLET_TRANSACTIONS_REQUEST_PENDING,
  GET_BOOKLET_TRANSACTIONS_REQUEST_SUCCESS,
  GET_BOOKLET_TRANSACTIONS_REQUEST_ERROR,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST,
  GET_BOOKLET_TRANSACTION_GROUPS,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_PENDING,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_SUCCESS,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_ERROR,
} from '../types/booklets'

function* getBookletsWatcher() {
  yield takeEvery(GET_BOOKLETS_REQUEST, getBookletsWorker)
}

function* createBookletWatcher() {
  yield takeEvery(CREATE_BOOKLET_REQUEST, createBookletWorker)
}

function* updateBookletWatcher() {
  yield takeEvery(UPDATE_BOOKLET_REQUEST, updateBookletWorker)
}

function* getBookletWatcher() {
  yield takeEvery(GET_BOOKLET_REQUEST, getBookletWorker)
}

function* getBookletTransactionsWatcher() {
  yield takeEvery(GET_BOOKLET_TRANSACTIONS_REQUEST, getBookletTransactionsWorker)
}

function* getBookletTransactionGroupsWatcher() {
  yield takeEvery(GET_BOOKLET_TRANSACTION_GROUPS_REQUEST, getBookletTransactionGroupsWorker)
}

function* getBookletsWorker({ payload: { page, size } = { page: 1, size: 20 } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_BOOKLETS_REQUEST_PENDING })

    const response = yield call(BookletsService.getBooklets, { page, size })
    const list = response.data?.data || []
    const total = Array.isArray(list) ? list.length : 0

    yield put({
      type: GET_BOOKLETS,
      payload: {
        items: list,
        pagination: {
          current: page,
          pageSize: size,
          total,
        },
      },
    })
    yield put({ type: GET_BOOKLETS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_BOOKLETS_REQUEST_ERROR,
      payload: error.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* createBookletWorker({ payload: { data, navigate } }) {
  try {
    yield put(showLoading())
    const response = yield call(BookletsService.createBooklet, data)
    const booklet = response.data.data
    yield put({ type: CREATE_BOOKLET, payload: booklet })
    yield put(
      notify({
        title: i18n.t('notifs.created'),
        status: 'success',
        dismissAfter: 4000,
        allowHTML: true,
      }),
    )
    if (navigate) {
      navigate('/main/booklets')
    }
    yield put(hideLoading())
  } catch (error) {
    const errorMessages = error.response?.data?.messages || [error.message]
    yield put({ type: CREATE_BOOKLET_REQUEST_ERROR, payload: errorMessages })
    const errorMessageKey = errorMessages[0]
    const translatedError = i18n.t(`booklets.error.${errorMessageKey}`, errorMessageKey)
    yield put(
      notify({
        title: translatedError,
        status: 'error',
        dismissAfter: 4000,
        allowHTML: true,
      }),
    )
    yield put(hideLoading())
  }
}

function* updateBookletWorker({ payload: { id, data, navigate } }) {
  try {
    yield put(showLoading())
    const response = yield call(BookletsService.updateBooklet, { id, data })
    const booklet = response.data.data
    yield put({ type: UPDATE_BOOKLET, payload: booklet })
    yield put(
      notify({
        title: i18n.t('notifs.updated'),
        status: 'success',
        dismissAfter: 4000,
        allowHTML: true,
      }),
    )
    if (navigate) {
      navigate('/main/booklets')
    }
    yield put(hideLoading())
  } catch (error) {
    const errorMessages = error.response?.data?.messages || [error.message]
    yield put({ type: UPDATE_BOOKLET_REQUEST_ERROR, payload: errorMessages })
    const errorMessageKey = errorMessages[0]
    const translatedError = i18n.t(`booklets.error.${errorMessageKey}`, errorMessageKey)
    yield put(
      notify({
        title: translatedError,
        status: 'error',
        dismissAfter: 4000,
        allowHTML: true,
      }),
    )
    yield put(hideLoading())
  }
}

function* getBookletWorker({ payload: { id } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_BOOKLETS_REQUEST_PENDING })

    const response = yield call(BookletsService.getBookletById, id)
    const booklet = response.data.data

    yield put({ type: GET_BOOKLET, payload: booklet })
    yield put({ type: GET_BOOKLETS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_BOOKLETS_REQUEST_ERROR,
      payload: error.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* getBookletTransactionsWorker({ payload }) {
  try {
    yield put({ type: GET_BOOKLET_TRANSACTIONS_REQUEST_PENDING })

    const response = yield call(BookletsService.getBookletTransactions, payload)
    const data = response.data.data

    yield put({ type: GET_BOOKLET_TRANSACTIONS, payload: data })
    yield put({ type: GET_BOOKLET_TRANSACTIONS_REQUEST_SUCCESS })
  } catch (error) {
    yield put({
      type: GET_BOOKLET_TRANSACTIONS_REQUEST_ERROR,
      payload: error.response?.data?.messages || [error.message],
    })
  }
}

function* getBookletTransactionGroupsWorker({ payload }) {
  try {
    yield put({ type: GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_PENDING })

    const response = yield call(BookletsService.getBookletTransactionGroups, payload)
    const data = response.data.data

    yield put({ type: GET_BOOKLET_TRANSACTION_GROUPS, payload: data })
    yield put({ type: GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_SUCCESS })
  } catch (error) {
    yield put({
      type: GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_ERROR,
      payload: error.response?.data?.messages || [error.message],
    })
  }
}

export default function* booklets() {
  yield all([
    fork(getBookletsWatcher),
    fork(createBookletWatcher),
    fork(updateBookletWatcher),
    fork(getBookletWatcher),
    fork(getBookletTransactionsWatcher),
    fork(getBookletTransactionGroupsWatcher),
  ])
}
